
















import { Vue, Component } from 'vue-property-decorator'
import VueMarkdown from 'vue-markdown'
import { getBlogPost } from '@/services/cms'
import ArticleView from '@/components/ArticleView.vue'

@Component({
  components: {
    VueMarkdown,
    ArticleView,
  },
})
export default class BlogPost extends Vue {

  metaInfo() {
    return {
      title: this.blogPost ? `${this.blogPost?.attributes.title} | Blog` : 'Blog post',
    }
  }

  loadingPost = false

  async mounted() {
    this.loadingPost = true
    await getBlogPost(this.$store, this.$route.params.blogPostId)
    this.loadingPost = false
  }

  get blogPost() {
    return this.$store.getters.blogPost(this.$route.params.blogPostId)
  }

  get links() {
    return [
      {
        title: 'More resources',
        links: [
          {
            label: 'Contact us',
            to: { name: 'contact' },
          },
          {
            label: 'Pricing',
            to: { name: 'pricing' },
          },
        ],
      },
    ]
  }

}
